import {checkIsProductionServer} from "@/helper";

const state = {
  // enabled: false,
  mainInstances: [
    {
      title: 'СООБЩИТЬ ОБ ОШИБКЕ',
      router: null,
      href: 'mailto:support@muctr.ru'
    },
    {
      title: 'Инструкция',
      router: null,
      href: 'https://wiki.muctr.ru/pages/viewpage.action?pageId=107978962'
    }
  ],
  secondInstances: [
    {
      name: "allServices",
      title: "Все сервисы",
      enabled: false,
      url: "https://portal.muctr.ru/tools"
    },
    {
      name: "muctr",
      title: "Официальный сайт",
      enabled: false,
      url:"https://muctr.ru/"
    },
    {
      name: "mail",
      title: "Корпоративная почта",
      enabled: false,
      url:"https://post.muctr.ru/"
    },
    {
      name: "paymuctr",
      title: "Оплата услуг университета",
      enabled: false,
      url:"https://pay.muctr.ru/"
    },
    {
      name: "queue",
      title: "Очередь на мат. помощь",
      enabled: false,
      url:"https://queue.muctr.ru/"
    },
    {
      name: "DissBreadcrumbs",
      title: "Диссоветы",
      url:"https://council.muctr.ru/",
      enabled: false
    }
  ],
  userActions: [
    {
      title: "Управление аккаунтом",
      url: checkIsProductionServer() ? 'https://portal.muctr.ru/' : 'https://portal-test.muctr.ru/',
    }
  ],

  title: "Сервис проведения опросов",
  userAvatar: null,
  is_page_loading: false
};

const mutations = {
  changeTitle(state, title) {
    /**
     * Изменяет состояние названия страницы
     * @param {string} title - Новое название страницы
     */
    state.title = title
  },
  changeAvatar(state, Avatar) {
    /**
     * Изменяет состояние аватара
     * @param {Object} Avatar - Новый аватар пользователя
     */
    state.userAvatar = Avatar
  },
  setStartLoading(state) {
    /**
     * Устанавливает состояние стартовой загрузки
     */
    state.is_page_loading = true
  },
  setEndRLoading(state) {
    /**
     * Снимает состояние стартовой загрузки
     */
    state.is_page_loading = false
  }
};


export default {
  namespaced: true,
  state,
  mutations
}
